import { useSearchParams } from "react-router-dom";

const useTranslation = () => {
  const [searchParams] = useSearchParams();
  const isEnglish = searchParams.get("lang") === "en" || false;

  return isEnglish;
};

export default useTranslation;
